// extracted by mini-css-extract-plugin
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--ba84d";
export var wysiwyg = "styles-module--wysiwyg--e53cd";
export var wysiwygContent = "styles-module--wysiwygContent--8f823";